import React, { useEffect, useRef, useState } from "react";
const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);
  const getBackgroundImage = () => {
    if (isMobile || isTablet) {
      return 'url("/lovable-uploads/7c1b750b-5999-4606-a871-41015ae93552.png")';
    } else {
      return 'url("/lovable-uploads/358fa03c-b7f1-4b2e-ba78-3bee04ecf515.png")';
    }
  };
  const getBackgroundSize = () => {
    if (isMobile) return '120% auto';
    if (isTablet) return '110% auto';
    return '100% auto';
  };
  return <footer className="w-full relative overflow-hidden" style={{
    backgroundImage: getBackgroundImage(),
    backgroundSize: getBackgroundSize(),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    zIndex: 10
  }}>
      {/* Content positioned over the background */}
      <div className="relative z-10 pt-28 md:pt-32 pb-6 py-[160px] mx-[15px] my-[10px]">
        <div className="section-container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
            {/* Logo and Description */}
            <div className="md:col-span-1 block md:hidden lg:block">
              <div className="text-2xl font-bold mb-4 text-white">
                ai<span style={{
                color: 'rgba(242, 76, 39, 1)'
              }}>4</span>hack
              </div>
              <p className="text-sm leading-relaxed text-white/70">
                Building the future of AI through innovation, collaboration, and breakthrough solutions. Join the next generation of AI pioneers.
              </p>
            </div>

            {/* Quick Links */}
            <div className="md:col-span-1">
              <h3 className="font-semibold mb-4 text-white">
                Quick Links
              </h3>
              <div className="space-y-2">
                {[{
                href: "/#mission",
                label: "Our Mission"
              }, {
                href: "/#why-participate",
                label: "Why Join"
              }, {
                href: "/#timing",
                label: "Timeline"
              }, {
                href: "/#faq",
                label: "FAQ"
              }].map(link => <a key={link.href} href={link.href} className="block text-sm transition-colors duration-200 hover:text-pulse-500 text-white/70">
                    {link.label}
                  </a>)}
              </div>
            </div>

            {/* Contact Info & Partnership */}
            <div className="md:col-span-1">
              <h3 className="font-semibold mb-4 text-white">
                Get in Touch
              </h3>
              <div className="space-y-3">
                <a href="mailto:hi@ai4hack.com" className="block text-sm transition-colors duration-200 hover:text-pulse-500 text-white/70">
                  hi@ai4hack.com
                </a>
                <a href="https://discord.gg/7JemaY27CG" target="_blank" rel="noopener noreferrer" className="block text-sm transition-colors duration-200 hover:text-pulse-500 text-white/70">
                  Join our Discord
                </a>
                <a href="mailto:hi@ai4hack.com?subject=Partnership Inquiry" className="block text-sm transition-colors duration-200 hover:text-pulse-500 text-white/70">
                  Partner with ai4hack
                </a>
                <a href="#participation-criteria" className="inline-block font-medium py-2 px-4 rounded-full transition-all duration-300 text-sm" style={{
                backgroundColor: 'rgba(242, 76, 39, 1)',
                color: 'white'
              }}>
                  Register Now
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-6 border-t border-gray-600">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-sm text-white/50">
                © 2025 ai4hack. All rights reserved.
              </p>
              <div className="flex space-x-6">
                <a href="/privacy-policy" className="text-sm transition-colors duration-200 hover:text-pulse-500 text-white/50">
                  Privacy Policy
                </a>
                <a href="/terms" className="text-sm transition-colors duration-200 hover:text-pulse-500 text-white/50">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;